import React, { useCallback, useEffect, useMemo, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link, useNavigate, useParams, useRoutes } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faLocationDot,
  faShareSquare,
  faSpinner,
  faUser,
  faHeart as faHeartS,
} from "@fortawesome/free-solid-svg-icons";
import { faCommentDots, faHeart } from "@fortawesome/free-regular-svg-icons";
import DatePicker from "react-datepicker";

import ThumnailImageSlider from "../Components/ThumnailImageSlider";
import { defaultImg, defaultUserImg, rightAngleImg } from "../Constants/Images";
import { Button, Form } from "react-bootstrap";
// import SpaceGridItem from "../Components/SpaceGridItem";
import { customDays, customHours, defaultAvailability } from "../Constants";

import Tabs from "../Components/Tabs";
import AboutTab from "../Components/DetailsTabs/AboutTab";
import FeaturesTab from "../Components/DetailsTabs/FeaturesTab";

import LocationTab from "../Components/DetailsTabs/LocationTab";
import HealthSafetyTab from "../Components/DetailsTabs/HealthSafetyTab";
import PolicyTab from "../Components/DetailsTabs/PolicyTab";
import ReviewTab from "../Components/DetailsTabs/ReviewTab";
import { API } from "../utils/Apis";
import { SpaceTypes } from "../Constants/Interfaces";
import moment from "moment";
import CustomButton from "../Components/Button";
import {
  calculateAmount,
  convertTimeTo12h,
  convertToMinutes,
  formatArea,
  formatSpaceRate,
  hasSpaceRate,
  SPACE_RATE_UNAVAILABLE_LABEL,
  SPACE_RATE_UNAVAILABLE_HELP_LONG,
  showToast,
} from "../utils/helpers";
import StripePaymentModal from "../Components/Modals/StripePaymentModal";
import useAuth from "../Hooks/useAuth";
import LoginModal from "../Components/Modals/LoginModal";
import AddChatMessages from "../Components/AddChatMessages";
import { toggleFavoriteAction } from "../Services/Store/Actions/SpaceActions";
import { useDispatch, useSelector } from "react-redux";
import ShareSpaceModal from "../Components/Modals/ShareSpaceModal";
import { webSiteUrl } from "../utils/env";

const defaultBookingData = {
  type: "normal",
  venueId: "",
  spaceId: "",
  day: "",
  startDate: moment().format("YYYY-MM-DD"),
  startTime: moment().format("HH:mm"),
  arrivalTime: "",
  endDate: "",
  endTime: "",
  grossAmount: "",
  offeredAmount: "",
  timeFrame: "15 minutes",
};

interface LoginModalType {
  show: boolean;
  afterLoginAction: Function | null;
}

const SpaceVanueDetails = () => {
  const { id } = useParams();

  const { isLoggedIn, user } = useAuth();
  const userFavSpaces = useSelector((state: any) => state.auth.favorites);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedTab, setSelectedTab] = useState("About");
  const [loading, setLoading] = useState(true);
  const [bookingLoading, setBookingLoading] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [showLogin, setShowLogin] = useState<LoginModalType>({
    show: false,
    afterLoginAction: null,
  });

  const [spaceItem, setSpaceItem] = useState<SpaceTypes | null>(null);
  const [sliderImages, setSliderImages] = useState([]);
  const [bookingData, setBookingData] = useState({ ...defaultBookingData });
  const [paymentInfos, setPaymentInfo] = useState({});
  const [bookingInfos, setBookingInfos] = useState({});
  const [showPaymentModal, togglePaymentModal] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [favLoading, setFavLoading] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const [disabledDates, setBookedDates] = useState([]);

  // Short-term arrival-time slots fetched from the space availability for the
  // selected date + duration.
  const [slots, setSlots] = useState<{ start: string; end: string }[]>([]);
  const [loadingSlots, setLoadingSlots] = useState(false);

  // Whether the user has manually edited the long-term offered amount. Until
  // they do, we keep it in sync with the calculated price as dates/times change.
  const [offeredTouched, setOfferedTouched] = useState(false);

  // Only offer short-term durations that meet the space's minimum booking
  // length (minHours). Falls back to the full list when no minimum is set.
  const availableHours = useMemo(() => {
    const minMinutes = (Number(spaceItem?.minHours) || 0) * 60;
    const filtered = customHours.filter(
      (h) => convertToMinutes(h.value) >= minMinutes
    );
    return filtered.length > 0 ? filtered : customHours;
  }, [spaceItem?.minHours]);

  // Calculated price for the long-term span currently selected (0 if incomplete
  // or invalid).
  const customCalculatedAmount = useMemo(() => {
    if (
      bookingData.type !== "custom" ||
      !bookingData.startDate ||
      !bookingData.startTime ||
      !bookingData.endDate ||
      !bookingData.endTime
    ) {
      return 0;
    }
    try {
      const amount = calculateAmount(
        spaceItem?.ratePerHour || "",
        moment(bookingData.startDate).format("YYYY-MM-DD"),
        bookingData.startTime,
        moment(bookingData.endDate).format("YYYY-MM-DD"),
        bookingData.endTime
      );
      return amount > 0 ? amount : 0;
    } catch {
      return 0;
    }
  }, [
    bookingData.type,
    bookingData.startDate,
    bookingData.startTime,
    bookingData.endDate,
    bookingData.endTime,
    spaceItem?.ratePerHour,
  ]);

  // Keep the offered amount in sync with the calculated price as long as the
  // user hasn't manually changed it.
  useEffect(() => {
    if (
      bookingData.type === "custom" &&
      !offeredTouched &&
      customCalculatedAmount > 0
    ) {
      setBookingData((prev) => ({
        ...prev,
        offeredAmount: String(customCalculatedAmount),
      }));
    }
  }, [bookingData.type, offeredTouched, customCalculatedAmount]);

  const tabs = [
    "About",
    "Features",
    "Location",
    "Health & Safety",
    "Policy",
    // "Review",
  ];

  const getBookedDates = useCallback(() => {
    console.log("bookingData :", bookingData);

    const duration = convertToMinutes(bookingData.timeFrame);

    const filters = {
      type: bookingData.type,
      duration,
    };
    API.getUnavailableDate(id, filters)
      .then((res) => {
        if (res.type === "success") {
          setBookedDates(res.bookedDates);

          // Only update startDate when the first-available date actually
          // changes, and use the functional updater so we don't capture stale
          // bookingData. Setting a fresh Date object every time would change
          // its identity and retrigger the slots effect in a loop.
          const nextDate = moment(res.firstAvailableDate).format("YYYY-MM-DD");
          setBookingData((prev) => {
            const prevDate = prev.startDate
              ? moment(prev.startDate).format("YYYY-MM-DD")
              : "";
            if (prevDate === nextDate) {
              return prev;
            }
            return {
              ...prev,
              startDate: new Date(res.firstAvailableDate),
            };
          });
        }
      })
      .catch((err) => {});
  }, [bookingData.type, bookingData.timeFrame]);

  // Normalized "YYYY-MM-DD" form of the selected date. Using the string (not
  // the Date object) as an effect dependency avoids re-fetching on every render
  // where a fresh Date instance with the same value is created.
  const startDateKey = bookingData.startDate
    ? moment(bookingData.startDate).format("YYYY-MM-DD")
    : "";

  // Fetch the available arrival-time slots for the selected date + duration.
  // Only relevant to short-term (normal) bookings.
  const getSlots = useCallback(() => {
    if (bookingData.type !== "normal" || !id || !startDateKey) {
      setSlots([]);
      return;
    }

    const duration = convertToMinutes(bookingData.timeFrame);

    setLoadingSlots(true);
    API.getDateSlots({ spaceId: id, date: startDateKey, duration })
      .then((res) => {
        if (res.type === "success" && res.data && Array.isArray(res.data.slots)) {
          setSlots(res.data.slots);
        } else {
          setSlots([]);
        }
      })
      .catch(() => setSlots([]))
      .finally(() => setLoadingSlots(false));
  }, [id, bookingData.type, bookingData.timeFrame, startDateKey]);

  const getSpaceDetails = () => {
    if (id) {
      API.getSpace(id)
        .then((res) => {
          if (res.type == "success") {
            setSpaceItem(res.data);

            if (res.data && res.data.media) {
              setSliderImages(res.data.media);
            }
          }
        })
        .catch((err) => {
          console.log("ERR :", err);
        })
        .finally(() => setLoading(false));
    }
  };

  const onChange = (field: string, value: string) => {
    setBookingData({
      ...bookingData,
      [field]: value,
    });
  };

  const submitBooking = () => {
    // Short-term bookings start at the selected arrival-time slot; long-term
    // bookings use the manually entered start time.
    const effectiveStartTime =
      bookingData.type === "normal"
        ? bookingData.arrivalTime
        : bookingData.startTime;

    // Enforce the space's minimum booking length for short-term bookings.
    const minHours = Number(spaceItem?.minHours) || 0;
    if (
      bookingData.type === "normal" &&
      minHours > 0 &&
      convertToMinutes(bookingData.timeFrame) < minHours * 60
    ) {
      showToast(
        "error",
        `This space has a minimum booking of ${minHours} hour${
          minHours > 1 ? "s" : ""
        }.`
      );
      return;
    }

    // Long-term validation up front, so it can't be skipped by later nesting.
    if (bookingData.type === "custom") {
      if (!bookingData.endDate || !bookingData.endTime) {
        showToast("error", "Please select an end date and time.");
        return;
      }
      if (!bookingData.startTime) {
        showToast("error", "Please select a start time.");
        return;
      }

      // startDate/endDate may be Date objects or strings — normalize each to
      // YYYY-MM-DD first, then combine with the HH:mm time. (Concatenating a
      // raw Date with a strict format string yields an invalid moment → NaN.)
      const cStart = moment(
        `${moment(bookingData.startDate).format("YYYY-MM-DD")} ${
          bookingData.startTime
        }`,
        "YYYY-MM-DD HH:mm"
      );
      const cEnd = moment(
        `${moment(bookingData.endDate).format("YYYY-MM-DD")} ${
          bookingData.endTime
        }`,
        "YYYY-MM-DD HH:mm"
      );
      const diffMinutes = cEnd.diff(cStart, "minutes");

      if (cEnd.isSameOrBefore(cStart)) {
        showToast("error", "The end time must be after the start time.");
        return;
      }
      if (diffMinutes < 1440) {
        showToast("error", "A long-term booking must be at least 24 hours.");
        return;
      }
    }

    if (!bookingData.startDate || bookingData.startDate === "") {
      showToast("error", "Please select event date.");
    } else if (!effectiveStartTime || effectiveStartTime === "") {
      showToast(
        "error",
        bookingData.type === "normal"
          ? "Please select an arrival time."
          : "Please select a start time."
      );
    } else {
      const startDate = moment(bookingData.startDate).set({
        hour: moment(effectiveStartTime, ["hh:mmA", "hh:mm A", "HH:mm"]).hour(),
        minute: moment(effectiveStartTime, [
          "hh:mmA",
          "hh:mm A",
          "HH:mm",
        ]).minute(),
        second: 0,
        millisecond: 0,
      });

      // Short-term: end is derived from the chosen duration. Long-term: the
      // user picks explicit end date + time.
      let endDate;
      if (bookingData.type === "custom") {
        endDate = moment(bookingData.endDate).set({
          hour: moment(bookingData.endTime, ["hh:mmA", "hh:mm A", "HH:mm"]).hour(),
          minute: moment(bookingData.endTime, [
            "hh:mmA",
            "hh:mm A",
            "HH:mm",
          ]).minute(),
          second: 0,
          millisecond: 0,
        });
        // (custom span already validated above)
      } else {
        const temp = String(bookingData.timeFrame).split(" ");
        endDate = startDate.clone().add(temp[0], temp[1]);
      }

      const startDateT = moment(bookingData.startDate).format("YYYY-MM-DD");
      const endDateT = moment(endDate).format("YYYY-MM-DD");
      const startTimeT = startDate.format("HH:mm");
      const endTime = moment(endDate).format("HH:mm");

      const grossAmount = calculateAmount(
        spaceItem?.ratePerHour || "",
        startDateT,
        startTimeT,
        endDateT,
        endTime
      );

      const data: any = {
        type: bookingData.type,
        venueId: (spaceItem && spaceItem.venueId) || "",
        spaceId: (spaceItem && spaceItem.id) || "",
        day: moment(bookingData.startDate).format("ddd"),
        startDate: startDateT,
        startTime: startTimeT,
        endDate: endDateT,
        endTime: endTime,
        grossAmount,
      };

      // For long-term bookings, send the client's offer (defaults to the
      // calculated price when the user hasn't lowered it).
      if (bookingData.type === "custom") {
        const offer =
          bookingData.offeredAmount !== "" &&
          !Number.isNaN(Number(bookingData.offeredAmount))
            ? Number(bookingData.offeredAmount)
            : grossAmount;

        if (!offer || offer <= 0) {
          showToast("error", "Please enter an offered amount greater than $0.");
          return;
        }
        if (offer > grossAmount) {
          showToast(
            "error",
            "Your offered amount can't be more than the calculated price."
          );
          return;
        }
        data.offeredAmount = offer;
      }

      console.log("BookingData:", data);

      if (!loading) {
        setBookingLoading(true);
        API.createBooking(data)
          .then((res) => {
            if (res.type === "success" && data.type == "normal") {
              setPaymentInfo(res.data.payment);
              setBookingInfos(res.data.booking);
            } else if (res.type === "success" && data.type == "custom") {
              showToast("success", res.message);

              setBookingData({ ...defaultBookingData });

              setTimeout(() => {
                getBookedDates();
              }, 1000);
            }
          })
          .catch((err) => {
            console.log("ERR :", err);
            showToast("error", err.message);
          })
          .finally(() => setBookingLoading(false));
      }
    }
  };

  const toggleFavorite = (id: string) => {
    if (!favLoading) {
      setFavLoading(true);

      toggleFavoriteAction({ spaceId: id }, dispatch)
        .then((res) => {
          console.log("RES:", res);
          showToast(res.type, res.message);
        })
        .catch((err) => {
          console.log("ERR:", err);
          showToast("error", err.message);
        })
        .finally(() => setFavLoading(false));
    }
  };

  const redirectTo = () => {
    navigate(`/search`);
  };

  useEffect(() => {
    getSpaceDetails();
  }, [id]);

  useEffect(() => {
    getBookedDates();
  }, [bookingData.type, bookingData.timeFrame]);

  useEffect(() => {
    getSlots();
  }, [getSlots]);

  // If the current short-term duration is below the space minimum (e.g. the
  // default 15 mins on a space with a multi-hour minimum), snap it to the
  // smallest allowed option.
  useEffect(() => {
    if (
      bookingData.type === "normal" &&
      availableHours.length > 0 &&
      !availableHours.some((h) => h.value === bookingData.timeFrame)
    ) {
      setBookingData((prev) => ({
        ...prev,
        timeFrame: availableHours[0].value,
      }));
    }
  }, [availableHours, bookingData.type, bookingData.timeFrame]);

  useEffect(() => {
    const PageTitle = spaceItem ? `${spaceItem.name} | Spacii ` : "";
    const name = spaceItem ? spaceItem.name : "";
    const description = spaceItem ? spaceItem.description : "";
    const image =
      spaceItem && spaceItem.media && spaceItem.media.length > 0
        ? spaceItem.media[0]["url"]
        : defaultImg;
    const url = `${webSiteUrl}/space/${spaceItem?.id}`;

    // Helper to create/update meta
    const setMeta = (attr: string, value: string, key = "name") => {
      let element = document.querySelector(`meta[${key}='${attr}']`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(key, attr);
        document.head.appendChild(element);
      }
      element.setAttribute("content", value);
    };

    // Update document title
    document.title = PageTitle;

    // Basic description
    setMeta("description", description);

    // Open Graph
    setMeta("og:title", name, "property");
    setMeta("og:description", description, "property");
    setMeta("og:image", image, "property");
    setMeta("og:url", url, "property");
    setMeta("og:type", "website", "property");

    // Twitter
    setMeta("twitter:card", "summary_large_image", "name");
    setMeta("twitter:title", name, "name");
    setMeta("twitter:description", description, "name");
    setMeta("twitter:image", image, "name");
  }, [spaceItem]);

  useEffect(() => {
    if (
      Object.entries(bookingInfos).length > 0 &&
      Object.entries(paymentInfos).length > 0
    ) {
      togglePaymentModal(true);
    }
  }, [bookingInfos, paymentInfos]);

  useEffect(() => {
    const screenResize = () => {
      const screenWidth = window.outerWidth;
      console.log("screenWidth :", screenWidth);

      setScreenWidth(screenWidth);
    };

    window.addEventListener("resize", screenResize);

    return () => window.removeEventListener("resize", screenResize);
  }, []);

  return (
    <React.Fragment>
      <Header />

      <div className="container mb-5">
        <div className="breadcrumb-wrapper">
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/search">Spaces</Link>
            </li>
            <li className="active">
              <Link to="#">{spaceItem?.name}</Link>
            </li>
          </ul>

          <div className="sharing-icons">
            <span className="as-link" onClick={() => setShareModal(true)}>
              <FontAwesomeIcon icon={faShareSquare} /> Share
            </span>

            <span
              className={
                spaceItem &&
                userFavSpaces &&
                userFavSpaces.includes(spaceItem.id)
                  ? "active as-link"
                  : "as-link"
              }
              onClick={() => {
                if (isLoggedIn) {
                  console.log("bookingInfos :", spaceItem);

                  toggleFavorite(spaceItem.id);
                } else {
                  setShowLogin({
                    show: true,
                    afterLoginAction: null,
                  });
                }
              }}
            >
              <FontAwesomeIcon
                icon={
                  spaceItem &&
                  userFavSpaces &&
                  userFavSpaces.includes(spaceItem.id)
                    ? faHeartS
                    : faHeart
                }
              />{" "}
              {favLoading ? <FontAwesomeIcon icon={faSpinner} spin /> : "save"}
            </span>
          </div>
        </div>

        {loading && (
          <div className="no-results">
            <p>
              <FontAwesomeIcon icon={faSpinner} spin />
            </p>
          </div>
        )}

        {!loading && !spaceItem && (
          <div className="no-reults">
            <p>Space Not Found</p>
            <Button onClick={() => redirectTo()}>Search Spaces</Button>
          </div>
        )}

        {!loading && spaceItem && (
          <>
            <div className="details-img-slider">
              <ThumnailImageSlider images={sliderImages} thumbsCount={7} />
            </div>

            <div className="details-content-wrapper">
              <div className="row">
                <div className="col-md-8 col-sm-8 col-xs-12">
                  <div className="content-heading-wrapper">
                    <h3>{spaceItem.name}</h3>
                    {spaceItem.tagLine && <h5>{spaceItem.tagLine}</h5>}

                    <div className="address-wrapper">
                      {spaceItem.address && (
                        <p>
                          <FontAwesomeIcon
                            icon={faLocationDot}
                            color="#4A4C56"
                          />{" "}
                          <span>{spaceItem.address}</span>
                        </p>
                      )}

                      <div className="row">
                        {/* <div className="col-md-6 col-xs-6 col-lg-3 mb-3">
                              <span>
                                <FontAwesomeIcon
                                  icon={faStar}
                                  color="#4A4C56"
                                />{" "}
                                4.8 (118 reviews)
                              </span>
                            </div> */}

                        {spaceItem.capacity && (
                          <div className="col-md-6 col-xs-6 col-lg-3 mb-3">
                            <span>
                              <FontAwesomeIcon icon={faUser} color="#4A4C56" />{" "}
                              {spaceItem.capacity} people
                            </span>
                          </div>
                        )}
                        {spaceItem.minHours && (
                          <div className="col-md-6 col-xs-6 col-lg-3">
                            <span>
                              <FontAwesomeIcon icon={faClock} color="#4A4C56" />{" "}
                              {spaceItem.minHours} hrs
                            </span>
                          </div>
                        )}
                        {spaceItem.area && (
                          <div className="col-md-6 col-xs-6 col-lg-3">
                            <span>
                              <img src={rightAngleImg} alt="" />{" "}
                              {formatArea(spaceItem.area)} sqft
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="tabs-content-wrapper">
                    {screenWidth < 1100 && (
                      <div className="form-group mt-4 mb-0">
                        <div className="custom-select">
                          <select
                            name="type"
                            className="form-control"
                            value={selectedTab}
                            onChange={(e) => setSelectedTab(e.target.value)}
                          >
                            {tabs.map((item, index) => (
                              <option
                                value={item}
                                key={`service-type-${index}`}
                              >
                                {item}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}

                    {screenWidth > 1100 && (
                      <Tabs
                        tabs={tabs}
                        selected={selectedTab}
                        setSelected={(val: string) => setSelectedTab(val)}
                      />
                    )}

                    {selectedTab === "About" && <AboutTab item={spaceItem} />}

                    {selectedTab === "Features" && (
                      <FeaturesTab item={spaceItem} />
                    )}

                    {selectedTab === "Location" && (
                      <LocationTab
                        item={spaceItem}
                        messageHost={() => setShowChat(true)}
                      />
                    )}

                    {selectedTab === "Health & Safety" && (
                      <HealthSafetyTab item={spaceItem} />
                    )}

                    {selectedTab === "Policy" && <PolicyTab item={spaceItem} />}

                    {selectedTab === "Review" && <ReviewTab item={spaceItem} />}
                  </div>
                </div>

                <div className="col-md-4 col-sm-4 col-xs-12">
                  <div className="booking-area-wrapper">
                    <div className="price-details">
                      <p>Add details to view total price</p>
                      {hasSpaceRate(spaceItem.ratePerHour) ? (
                        <h4>
                          {formatSpaceRate(spaceItem.ratePerHour, {
                            suffix: "/hr",
                          })}
                        </h4>
                      ) : (
                        <div className="price-unavailable-block">
                          <span className="price-unavailable-label">
                            {SPACE_RATE_UNAVAILABLE_LABEL}
                          </span>
                          <span className="price-unavailable-help">
                            {SPACE_RATE_UNAVAILABLE_HELP_LONG}
                          </span>
                        </div>
                      )}
                      <span>{spaceItem.minHours} hr minimum</span>
                    </div>

                    {/* <div className="discount-wrapper">
                      <span>8+ hour discount</span>
                      <span className="tag">
                        {spaceItem.discountHours}% off
                      </span>
                    </div> */}

                    <div className="booking-form-wrapper">
                      <h3>Date and time*</h3>

                      <form>
                        <div className="form-group">
                          <label className="d-block">Booking Type</label>

                          <div className="booking-type-options">
                            <Form.Check
                              inline
                              id="booking-type-normal"
                              type="radio"
                              label="Short Term"
                              onChange={(e) => {
                                setOfferedTouched(false);
                                setBookingData({
                                  ...bookingData,
                                  type: "normal",
                                  timeFrame: availableHours[0].value,
                                });
                              }}
                              checked={bookingData.type === "normal"}
                            />

                            <Form.Check
                              inline
                              id="booking-type-custom"
                              type="radio"
                              label="Long Term"
                              onChange={(e) => {
                                // Long-term must span at least 24 hours, so
                                // default the end to start + 1 day.
                                const startD =
                                  bookingData.startDate ||
                                  moment().format("YYYY-MM-DD");
                                const startT =
                                  bookingData.startTime ||
                                  moment().format("HH:mm");
                                setBookingData({
                                  ...bookingData,
                                  type: "custom",
                                  timeFrame: customDays[0].value,
                                  startDate: startD,
                                  startTime: startT,
                                  endDate: moment(startD)
                                    .add(1, "day")
                                    .format("YYYY-MM-DD"),
                                  endTime: startT,
                                });
                              }}
                              checked={bookingData.type === "custom"}
                            />
                          </div>
                        </div>

                        {/* Short-term: pick a duration + date, then an arrival
                            slot below. */}
                        {bookingData.type === "normal" && (
                          <div className="row">
                            <div className="col-md-6 col-sm-12">
                              <div className="form-group">
                                <label>Time Block</label>
                                <div className=" custom-select">
                                  <select
                                    name="timeFrame"
                                    className="form-control"
                                    onChange={(e) =>
                                      onChange("timeFrame", e.target.value)
                                    }
                                    value={bookingData.timeFrame}
                                  >
                                    <option>Select</option>
                                    {availableHours.map((day, index) => (
                                      <option
                                        value={day.value}
                                        key={`time-block-${day.value}-${index}`}
                                      >
                                        {day.label}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12">
                              <div className="form-group">
                                <label>Event Date</label>
                                <div className="with-icon">
                                  {spaceItem && (
                                    <DatePicker
                                      showIcon
                                      icon="far fa-calendar"
                                      value={
                                        bookingData.startDate
                                          ? moment(
                                              bookingData.startDate
                                            ).format("MM/DD/YYYY")
                                          : ""
                                      }
                                      selected={bookingData.startDate}
                                      minDate={new Date()}
                                      className="form-control"
                                      placeholderText="MM/DD/YYYY"
                                      onChange={(date: Date | undefined) => {
                                        onChange("startDate", date);
                                      }}
                                      excludeDates={disabledDates}
                                      filterDate={(date) => {
                                        const day = date.getDay();
                                        const workingDays =
                                          spaceItem.days || [];

                                        const indexes =
                                          defaultAvailability.reduce(
                                            (acc, item, i) => {
                                              if (
                                                !workingDays.includes(item.day)
                                              )
                                                acc.push(i);
                                              return acc;
                                            },
                                            [] as number[]
                                          );

                                        return !indexes.includes(day);
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Long-term: explicit start/end dates and times. */}
                        {bookingData.type === "custom" && (
                          <div className="row">
                            <div className="col-md-6 col-sm-12">
                              <div className="form-group">
                                <label>Start Date</label>
                                <div className="with-icon">
                                  <DatePicker
                                    showIcon
                                    icon="far fa-calendar"
                                    value={
                                      bookingData.startDate
                                        ? moment(bookingData.startDate).format(
                                            "MM/DD/YYYY"
                                          )
                                        : ""
                                    }
                                    selected={
                                      bookingData.startDate
                                        ? new Date(bookingData.startDate)
                                        : null
                                    }
                                    minDate={new Date()}
                                    className="form-control"
                                    placeholderText="MM/DD/YYYY"
                                    onChange={(date: Date | undefined) =>
                                      onChange(
                                        "startDate",
                                        date
                                          ? moment(date).format("YYYY-MM-DD")
                                          : ""
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6 col-sm-12">
                              <div className="form-group">
                                <label>Start Time</label>
                                <input
                                  type="time"
                                  name="startTime"
                                  placeholder="Select Time"
                                  className="form-control"
                                  value={bookingData.startTime}
                                  onChange={(e) =>
                                    onChange("startTime", e.target.value)
                                  }
                                />
                              </div>
                            </div>

                            <div className="col-md-6 col-sm-12">
                              <div className="form-group">
                                <label>End Date</label>
                                <div className="with-icon">
                                  <DatePicker
                                    showIcon
                                    icon="far fa-calendar"
                                    value={
                                      bookingData.endDate
                                        ? moment(bookingData.endDate).format(
                                            "MM/DD/YYYY"
                                          )
                                        : ""
                                    }
                                    selected={
                                      bookingData.endDate
                                        ? new Date(bookingData.endDate)
                                        : null
                                    }
                                    minDate={
                                      bookingData.startDate
                                        ? new Date(bookingData.startDate)
                                        : new Date()
                                    }
                                    className="form-control"
                                    placeholderText="MM/DD/YYYY"
                                    onChange={(date: Date | undefined) =>
                                      onChange(
                                        "endDate",
                                        date
                                          ? moment(date).format("YYYY-MM-DD")
                                          : ""
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6 col-sm-12">
                              <div className="form-group">
                                <label>End Time</label>
                                <input
                                  type="time"
                                  name="endTime"
                                  placeholder="Select Time"
                                  className="form-control"
                                  value={bookingData.endTime}
                                  onChange={(e) =>
                                    onChange("endTime", e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Short-term: pick an arrival-time slot from the
                            space's availability for the selected day + duration. */}
                        {bookingData.type === "normal" && (
                          <div className="time-blocks-wrapper">
                            <div className="time-blocks-heading">
                              <span className="label">Arrival Time</span>
                              <span className="increments">
                                {bookingData.timeFrame} increments
                              </span>
                            </div>

                            <div className="time-blocks">
                              {loadingSlots && (
                                <p className="time-blocks-msg">
                                  <FontAwesomeIcon icon={faSpinner} spin />
                                </p>
                              )}

                              {!loadingSlots && slots.length === 0 && (
                                <p className="time-blocks-msg">
                                  No time blocks available for the selected date
                                  and duration.
                                </p>
                              )}

                              {!loadingSlots && slots.length > 0 && (
                                <div className="time-blocks-grid">
                                  {slots.map((slot, index) => (
                                    <div
                                      key={`arrival-${slot.start}-${index}`}
                                      className={`arrival-time-item ${
                                        bookingData.arrivalTime === slot.start
                                          ? "active"
                                          : ""
                                      }`}
                                      onClick={() =>
                                        onChange("arrivalTime", slot.start)
                                      }
                                    >
                                      {convertTimeTo12h(slot.start)}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Long-term: client offers an amount the host reviews. */}
                        {bookingData.type === "custom" && (
                          <div className="form-group">
                            <label>Offered Amount</label>
                            <div className="offered-amount-input">
                              <span className="currency">$</span>
                              <input
                                type="number"
                                min={1}
                                step="0.01"
                                name="offeredAmount"
                                placeholder="0.00"
                                className="form-control"
                                value={bookingData.offeredAmount}
                                onChange={(e) => {
                                  setOfferedTouched(true);
                                  onChange("offeredAmount", e.target.value);
                                }}
                              />
                            </div>
                          </div>
                        )}

                        <CustomButton
                          isLoading={bookingLoading}
                          title="Request to Book"
                          onClick={() => {
                            console.log("isLoggedIn :", isLoggedIn);

                            if (isLoggedIn) {
                              submitBooking();
                            } else {
                              setShowLogin({
                                show: true,
                                afterLoginAction: null,
                              });
                            }
                          }}
                        />
                      </form>

                      <div className="response-wrapper">
                        {/* <p>
                          {spaceItem?.user?.name} typically responds within 7
                          hrs
                        </p>
                        <p>You won't be charged yet.</p> */}

                        <span
                          className="as-link"
                          onClick={() => {
                            if (isLoggedIn) {
                              setShowChat(true);
                            } else {
                              setShowLogin({
                                show: true,
                                afterLoginAction: () => setShowChat(true),
                              });
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faCommentDots} /> Message Host
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="popular-vanues-wrapper">
              <div className="popular-vanues-heading">
                <h3>Popular event spaces near Washington, D.C.</h3>

                <span className="read-more-link">
                  View More <FontAwesomeIcon icon={faArrowRight} />
                </span>
              </div>

              {popularSpaceVanue.length > 0 && (
                <div className="row">
                  {popularSpaceVanue.map((item) => (
                    <div
                      key={`space-item-${item.id}`}
                      className="col-md-3 col-sm-6 col-xs-12"
                    >
                      <SpaceGridItem item={item} onClick={() => {}} />
                    </div>
                  ))}
                </div>
              )}
            </div> */}
          </>
        )}
      </div>

      {shareModal && (
        <ShareSpaceModal
          show={shareModal}
          closeModal={() => setShareModal(false)}
          name={spaceItem ? spaceItem.name : ""}
          title={`Checkout this awesome place ${spaceItem?.name}`}
          content={`${String(spaceItem?.description).substring(0, 80)}...`}
          url={`${webSiteUrl}/space/${spaceItem?.id}`}
        />
      )}

      {showPaymentModal && (
        <StripePaymentModal
          show={showPaymentModal}
          onClose={() => togglePaymentModal(false)}
          bookingInfo={bookingInfos}
          paymentInfo={paymentInfos}
          spaceItem={spaceItem}
          resetForm={() => setBookingData({ ...defaultBookingData })}
        />
      )}

      {showLogin.show && (
        <LoginModal
          show={showLogin.show}
          onClose={() => setShowLogin({ show: false, afterLoginAction: null })}
          onSuccess={() => {
            setShowLogin({ show: false, afterLoginAction: null });
            if (showLogin.afterLoginAction) {
              showLogin.afterLoginAction();
            }
          }}
        />
      )}

      {showChat && (
        <AddChatMessages
          spaceAuthor={spaceItem && spaceItem.user}
          closeChat={() => setShowChat(false)}
        />
      )}

      <Footer />
    </React.Fragment>
  );
};

export default SpaceVanueDetails;
